import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  IconButton,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
} from '@mui/material';
import {
  BugReport,
  Refresh as RefreshIcon,
  Clear as ClearIcon,
  MoreVert as MoreVertIcon,
} from '@mui/icons-material';

const mockDebugLogs = [
  {
    id: 1,
    timestamp: '2024-02-13 11:30:00',
    level: 'error',
    component: 'API',
    message: 'Failed to connect to database',
  },
  {
    id: 2,
    timestamp: '2024-02-13 11:29:00',
    level: 'warning',
    component: 'Auth',
    message: 'Rate limit threshold reached',
  },
  {
    id: 3,
    timestamp: '2024-02-13 11:28:00',
    level: 'info',
    component: 'Cache',
    message: 'Cache invalidation triggered',
  },
];

export default function Debug() {
  const getLevelColor = (level: string) => {
    switch (level) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'default';
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Debug Console
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <BugReport sx={{ mr: 1 }} />
                <Typography variant="h6">System Status</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" paragraph>
                Memory Usage: 45%
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                CPU Load: 32%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Active Connections: 156
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">Debug Tools</Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<RefreshIcon />}
                >
                  Refresh
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  startIcon={<ClearIcon />}
                >
                  Clear Logs
                </Button>
              </Box>
            </Box>
            <TextField
              fullWidth
              label="Debug Command"
              placeholder="Enter debug command..."
              size="small"
              sx={{ mb: 2 }}
            />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <List>
              {mockDebugLogs.map((log) => (
                <ListItem key={log.id} divider>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip
                          label={log.level.toUpperCase()}
                          color={getLevelColor(log.level) as any}
                          size="small"
                        />
                        <Typography component="span">
                          [{log.component}] {log.message}
                        </Typography>
                      </Box>
                    }
                    secondary={log.timestamp}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" size="small">
                      <MoreVertIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
} 